export default __webpack_public_path__ + "static/media/initial_brief.7a79a65b.svg";